var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 193.528,
    height: 159.172,
    viewBox: "0 0 193.528 159.172",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_363",
    "data-name": "Path 363",
    d: "M-2832.452,5224.345h193.527V5065.173h-193.527Z",
    transform: "translate(2925 -122)",
    fill: "none",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Component_28_2",
    "data-name": "Component 28 \\u2013 2",
    transform: "translate(0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-92.548 -4943.173)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_97",
    "data-name": "Group 97",
    transform: "translate(-3334.73 2872.493)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_364",
    "data-name": "Path 364",
    d: "M3729.849,2110.422s5.557-6.708,14.183-5.769,17.481,9.928,20.969,19.857-.3,25.12-9.606,29.734-22.336-.2-22.336-.2-8.711-2.3-11.126-15.98S3722.469,2110.422,3729.849,2110.422Z",
    transform: "translate(-218.28 0)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_96",
    "data-name": "Group 96",
    transform: "translate(3452.938 2116.024)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_365",
    "data-name": "Path 365",
    d: "M3599.4,2475.318l-3.1.006-16.377.038-4,.01-24.841.056-42.06.1-20.4.046-4.769.012-22.329.05c-6.318-78.351,25.711-95.85,39.286-98.514l.223-.042c.647-.121,4.627-.248,7.593-.328a10.042,10.042,0,0,0,7.756-3.969c4.546-6.042,4.085-15.052,4.125-21.25,0-.374,0-.736,0-1.089-.006-.664-.022-1.288-.042-1.861,0-.108-.008-.215-.012-.318-.06-1.6-.153-2.554-.153-2.554h21.068a70.172,70.172,0,0,0-.157,8.342c0,.064,0,.128.006.2.04,1.034.1,2.073.2,3.109.231,2.5.333,4.985.624,7.346a13.594,13.594,0,0,0,12.917,11.926c.488.02.956.048,1.384.083a11.056,11.056,0,0,1,2.739.229c3.8.707,11.085,3.4,18.964,13.4h0C3590.489,2403.348,3602.986,2428.261,3599.4,2475.318Z",
    transform: "translate(-3459.267 -2312.31)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_366",
    "data-name": "Path 366",
    d: "M3806.16,2354.052c-1.753,3.248-4.411,6.194-8.205,5.72-5.945-.743-10.7-6.3-12.713-9.329-.006-.664-.022-1.288-.042-1.861,0-.108-.008-.215-.012-.318l10.622-2.554h10.51A69.441,69.441,0,0,0,3806.16,2354.052Z",
    transform: "translate(-3723.377 -2312.31)",
    fill: "#723ed3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_367",
    "data-name": "Path 367",
    d: "M3593.069,2607.56l-3.134.006-16.547.038-4.039.01-25.1.056-42.5.1-20.613.046-4.818.012-22.561.05c-6.384-78.351,25.978-95.85,39.693-98.514,2.307,6.671,10,24.34,29.168,33.551,0,0,19.8-4.516,29.707-33.732,3.836.706,11.2,3.4,19.161,13.4h0C3584.061,2535.589,3596.688,2560.5,3593.069,2607.56Z",
    transform: "translate(-3452.938 -2445.372)",
    fill: "#4527a0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_94",
    "data-name": "Group 94",
    transform: "translate(51.894 0)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_368",
    "data-name": "Path 368",
    d: "M3865.969,2291.334a155.07,155.07,0,0,0-2.773,22.852l.862,2.113a149.1,149.1,0,0,0,8.86,13.987c5.427,7.055,8.862,35.369-12.5,46.27,0,0,8.413-8.08,3.851-24.468-4.908-17.631-3.922-24.822-3.906-34.347l-.79-2.363a70.468,70.468,0,0,0-12.925-9.042C3838.643,2301.909,3860.4,2284.331,3865.969,2291.334Z",
    transform: "translate(-3823.875 -2268.724)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_369",
    "data-name": "Path 369",
    d: "M3923.778,2422.726l3.623-1.429.862,2.533-3.695,1.729Z",
    transform: "translate(-3888.08 -2376.211)",
    fill: "#4527a0"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_93",
    "data-name": "Group 93",
    transform: "translate(0 -3.1)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_92",
    "data-name": "Group 92",
    transform: "translate(0 18.418)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_370",
    "data-name": "Path 370",
    d: "M3731.887,2273.81c0-2.591,1.547-3.313,3.662-3.313s3.83,2.1,3.83,4.691-1.63,5.56-3.746,5.56S3731.887,2276.4,3731.887,2273.81Z",
    transform: "translate(-3731.887 -2270.497)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_372",
    "data-name": "Path 372",
    d: "M3915.1,2273.81c0-2.591-1.547-3.313-3.662-3.313s-3.83,2.1-3.83,4.691,1.631,5.56,3.746,5.56S3915.1,2276.4,3915.1,2273.81Z",
    transform: "translate(-3874.921 -2270.497)",
    fill: "#9460f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_374",
    "data-name": "Path 374",
    d: "M3782.139,2208.137c-2.828,3.315-6.066,3.728-10.361,3.656-4.287.073-7.869-2.062-10.695-5.377a.478.478,0,0,0-.052-.06c-3.693-4.764-5.243-11.115-5.275-18.6v0a70.522,70.522,0,0,1,.554-8.765,12.9,12.9,0,0,1,.823-3.268c2.3-5.761,8.3-8.206,11.87-9.175a10.6,10.6,0,0,1,5.551,0c3.568.969,9.578,3.414,11.872,9.175a12.88,12.88,0,0,1,.823,3.268,73.413,73.413,0,0,1,.543,7.378v0C3787.951,2194.487,3786.1,2203.075,3782.139,2208.137Z",
    transform: "translate(-3751.315 -2166.174)",
    fill: "#9460f5"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_16",
    "data-name": "Ellipse 16",
    cx: 0.984,
    cy: 0.984,
    r: 0.984,
    transform: "translate(24.981 21.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_17",
    "data-name": "Ellipse 17",
    cx: 0.984,
    cy: 0.984,
    r: 0.984,
    transform: "translate(13.356 21.086)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_375",
    "data-name": "Path 375",
    d: "M3862.2,2250.191c.374.192.164.635-.284.6-.981-.071-2.365-.141-3.94-.134-3.1.015-3.9-.015-3.623-.819s3.387-.788,5.327-.51A8.274,8.274,0,0,1,3862.2,2250.191Z",
    transform: "translate(-3831.526 -2234.36)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_376",
    "data-name": "Path 376",
    d: "M3781.592,2250.191c-.373.192-.164.635.285.6.98-.071,2.365-.141,3.94-.134,3.1.015,3.9-.015,3.623-.819s-3.387-.788-5.327-.51A8.278,8.278,0,0,0,3781.592,2250.191Z",
    transform: "translate(-3772.188 -2234.36)",
    fill: "#fff"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_377",
    "data-name": "Path 377",
    d: "M3831.255,2339.129l6.7-.792s.159,2.111-2.811,2.419S3831.255,2339.129,3831.255,2339.129Z",
    transform: "translate(-3762.231 -2306.164)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_95",
    "data-name": "Group 95",
    transform: "translate(70.892 25.986)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_378",
    "data-name": "Path 378",
    d: "M3834.935,2309.625c-.041,0-.081,0-.121-.005a.861.861,0,0,1-.682-.375c-.348-.541.116-2.8.212-3.251a.175.175,0,1,1,.343.073,8.121,8.121,0,0,0-.26,2.988.536.536,0,0,0,.418.215,1.4,1.4,0,0,0,1.043-.4.175.175,0,1,1,.257.239A1.735,1.735,0,0,1,3834.935,2309.625Z",
    transform: "translate(-3834.005 -2305.855)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_379",
    "data-name": "Path 379",
    d: "M4042.36,2811.491l-2.682.009-3.041-52.84Z",
    transform: "translate(-3928.049 -2648.438)",
    fill: "#120283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_380",
    "data-name": "Path 380",
    d: "M3611.4,2811.491l2.681.009,3.041-52.84Z",
    transform: "translate(-3581.92 -2648.438)",
    fill: "#120283"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_385",
    "data-name": "Path 385",
    d: "M1284.006,1416.756c-1.9,3.529-4.793,6.73-8.914,6.214-6.459-.807-11.623-6.844-13.812-10.134-.007-.721-.024-1.4-.046-2.022,0-.118-.009-.234-.013-.345l11.54-2.775h11.417A75.473,75.473,0,0,0,1284.006,1416.756Z",
    transform: "translate(-1002.472 -1687.916)",
    fill: "#9460f5"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_382",
    "data-name": "Path 382",
    d: "M3751.205,2165s-.738,2.728.714,3.125,1.91-13.188,4.75-15,8.741-2.214,10.721,2.214,12.761,16.947,20.251,10.688-3.892-25.48-16.867-23.769S3750.145,2151.317,3751.205,2165Z",
    transform: "translate(-242.626 -30.598)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg2);
export default __webpack_public_path__ + "static/media/2.c30d4a767d984c583a527629dfdef028.svg";
export { ForwardRef as ReactComponent };